import React from 'react';
import {
  hasPermission,
  hasAnyPermission
} from '../../utils/PermissionUtils';

const Sidebar = ({
  activeItem,
  onItemClick
}) => {

  const menuItems = [
    {
      id: 'client',
      label: 'Client Portal',
      show: hasPermission('ClientPortal.View')
    },

    {
      id: 'maintainance',
      label: 'Maintenance',
      show: hasPermission('Maintenance.View')
    },
    {
      id: 'JobsModule',
      label: 'Jobs',
      show: hasPermission('Job.View')
    },

    {
      id: 'tallies',
      label: 'Integrations',
      show: hasAnyPermission([
        'Tallies.View',
        'LoL.View'
      ])
    },
    {
      id: 'reports',
      label: 'Reports',
      show: hasPermission('Reports.View')
    },

  ];

  const visibleMenuItems = menuItems.filter(
    item => item.show
  );

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <img
          src="../../assets/sidebar-fold-icon.png"
          alt="sidebar-fold-icon"
          className="sidebar-fold-icon"
        />
      </div>

      <nav className="sidebar-nav">
        <ul>
          {visibleMenuItems.map(item => (
            <li key={item.id}>
              <button
                className={`sidebar-item ${activeItem === item.id
                  ? 'active'
                  : ''
                  }`}
                onClick={() =>
                  onItemClick(item.id)
                }
              >
                <span className="sidebar-label">
                  {item.label}
                </span>
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
